import BaseIcon from './base-icon';

class ArrowRightIcon extends BaseIcon {
  renderSVG(): string {
    return `
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        stroke-width="1"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M5 12H19"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13 6L19 12L13 18"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    `;
  }
}

customElements.define('arrow-right-icon', ArrowRightIcon);
